import React, { useEffect, useState } from "react";
import { TbGalaxy } from "react-icons/tb";
import { useParams } from "react-router-dom";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const OAuthMain = () => {
    const account_id = localStorage.getItem("account_id");
    const { org_id, abty_id, version } = useParams()
    const [loading, setLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });
    const [fields, setFields] = useState([]);

    const handleStep1 = async () => {
        setLoading(true);
        setErrorMessage({ message: "", display: false });
        const redirect_uri = window.location.origin;
        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/get_custom_auth`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    account_id,
                    org_id,
                    mcp_id: abty_id,
                    version: version,
                    redirect_uri
                }),
            });

            const result = await response.json();
            if (result.status == "success") {
                if (result.fields) {
                    setFields(result.fields);
                } else if (result.url) {
                    window.location.href = result.url;
                } else if (!result.fields) {
                }
            }
        } catch (err) {
            setLoading(false);
            setErrorMessage({ message: "An error occurred. Please try again.", display: true });
            console.error("Step1 Error:", err);
        } finally {
            setLoading(false)
        }

    };

    // useEffect(() => {
    //     handleStep1()
    // }, [])

    return (
        <div className="main_oauth_cont">
            <div className="main_oauth">
                <div className="main_oauth_inner">
                    <div className="header_oauth">
                        <i><TbGalaxy/></i>
                        <p>E8 Oauth</p>
                    </div>
                        <p className="main_oauth_p">You're about to access this ability published by Project E8</p>
                </div>
                <div className="main_oauth_inner">
                    
                </div>
            </div>
        </div>
    )
}

export default OAuthMain